var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlastWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8626 15.8995L29.6728 13.5026L31.3309 8.4133L28.0147 6H5.93382L0.828125 9.79234H26.7834L25.4043 14.0608H14.996L13.9946 17.18H24.4029L21.4807 26.1602L26.3565 23.7467L28.0968 18.3621L24.8298 15.9651L24.8626 15.8995Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16364 22.3023L11.168 12.9446L7.83531 10.4492L2.82812 26.1603H21.4778L22.7255 22.3023H8.16364Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlastWhite);
export default __webpack_public_path__ + "static/media/blast-white.33c19cb4a397861c3985f7b701e23bbe.svg";
export { ForwardRef as ReactComponent };